export default function Configure($stateProvider) {
    $stateProvider.state('modelessaisies', {
        parent: 'common',
        url: '/modelessaisies',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.SAISIES" | translate }}'
        }
    });

    $stateProvider.state('modelessaisies.list', {
        url: '/list',
        template: '<modeles-saisies></modeles-saisies>',
        rights: { domain: 'modelessaisies', right: 'read' },
        ncyBreadcrumb: {
            parent: 'modelessaisies',
            label: '{{ "MODELES_SAISIES.BREADCRUMBS.MODELES_SAISIES_LIST" | translate}}'
        },
        navigation: {
            menu: 'laboratoire_donnees',
            translate: 'MODELES_SAISIES.BREADCRUMBS.MODELES_SAISIES_LIST',
            order: 6,
            navigationCls: 'menu-item-separator'
        },
        search: 'MODELES_SAISIES.BREADCRUMBS.MODELES_SAISIES_LIST'
    });

    $stateProvider.state('modelessaisies.list.detail', {
        url: '/{id}',
        template: '<modele-saisie-detail></modele-saisie-detail>',
        rights: { domain: 'modelessaisies', right: 'read' },
        ncyBreadcrumb: {
            parent: 'modelessaisies.list',
            label: '{{ "MODELES_SAISIES.BREADCRUMBS.MODELE_SAISIE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('modelessaisies.new', {
        url: '/new',
        template: '<modele-saisie-form></modele-saisie-form>',
        rights: { domain: 'modelessaisies', right: 'create' },
        ncyBreadcrumb: {
            parent: 'modelessaisies.list',
            label: '{{ "MODELES_SAISIES.BREADCRUMBS.MODELE_SAISIE_NEW" | translate}}'
        },
        search: 'MODELES_SAISIES.BREADCRUMBS.MODELE_SAISIE_NEW'
    });

    $stateProvider.state('modelessaisies.edit', {
        url: '/{id}/edit',
        template: '<modele-saisie-form></modele-saisie-form>',
        rights: { domain: 'modelessaisies', right: 'update' },
        ncyBreadcrumb: {
            parent: 'modelessaisies.list',
            label: '{{ "MODELES_SAISIES.BREADCRUMBS.MODELE_SAISIE_EDIT" | translate }}'
        }
    });

    $stateProvider.state('modelessaisies.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: { parentState: 'modelessaisies.new' },
        ncyBreadcrumb: {
            parent: 'modelessaisies.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });

    $stateProvider.state('modelessaisies.duplicate', {
        url: '/{id}/duplicate',
        template: '<modele-saisie-form></modele-saisie-form>',
        rights: { domain: 'modelessaisies', right: 'create' },
        ncyBreadcrumb: {
            parent: 'modelessaisies.list',
            label: '{{ "MODELES_SAISIES.BREADCRUMBS.MODELE_SAISIE_NEW" | translate}}'
        },
        params: {
            duplicate: true
        }
    });
}

Configure.$inject = ['$stateProvider'];
